import React from "react";

export interface KeyFact {
  label: string;
  sublabel: string;
}

interface KeyFactsBarProps {
  facts?: KeyFact[];
}

/**
 * Machine-quotable numbers rendered directly under the answer block.
 *
 * This is the AEO surface answer engines lift alongside the definition, so it
 * must stay in the server HTML and keep a stable shape across every page type.
 * It previously existed as three drifting copies (ServiceClient,
 * DashboardLandingClient, FabricBeratungClient).
 *
 * Renders nothing when there are no facts.
 */
export default function KeyFactsBar({ facts }: KeyFactsBarProps) {
  if (!Array.isArray(facts) || facts.length === 0) {
    return null;
  }

  return (
    <ul className="keyfacts-bar">
      {facts.map((fact) => (
        <li key={fact.label}>
          <strong>{fact.label}</strong>
          <span>{fact.sublabel}</span>
        </li>
      ))}
    </ul>
  );
}
